var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app","dir":_vm.$store.state.lang === 'ar' ? 'rtl' : 'ltr'}},[_c('router-view',{key:_vm.$store.state.lang})],1)}
var staticRenderFns = []

export { render, staticRenderFns }